.searched-candidates-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.6rem;
  padding-inline-end: 1.2rem;
  overflow-y: auto;
  padding-bottom: 1.6rem;

  @media screen and (max-width: #{$bp-small - 1}) {
    height: 100%;
  }

  @media screen and (min-width: $bp-small) {
    min-height: 50%;
    max-height: 50%;
    border-bottom: 0.1rem solid var(--color-grayscale-trout, #494e5a);

    & > div {
      cursor: pointer;
    }
  }
}
